export const MenuItems = [
  {
    title: "Home",
    url: "/",
    className: "nav-links",
    icon: "fa-solid fa-house-user",
  },
  {
    title: "About",
    url: "/about",
    className: "nav-links",
    icon: "fa-solid fa-circle-info",
  },
  {
    title: "Service",
    url: "/service",
    className: "nav-links",
    icon: "fa-solid fa-briefcase",
  },
  {
    title: "Contact",
    url: "/contact",
    className: "nav-links",
    icon: "fa-solid fa-address-book",
  },
  {
    title: "Sign Up",
    url: "/signup",
    className: "nav-links-mobile",
  },
];